import { combineReducers } from 'redux';
import * as customerReducer from './customer/reducer';
import * as licenseReducer from './license/reducer';
import * as loginReducer from './login/reducer';
import * as userReducer from './user/reducer';
import * as popupReducer from './popup/reducer';

import { History } from 'history';
import { RouterState, connectRouter } from 'connected-react-router';

/*
 * Root state of the app
 * Contains every substate of the app
 */
export interface IStore {
  router?: RouterState; // optional because connected-react-router initializes its own an initial state that is not exposed
  userReducer: userReducer.IUserState;
  customerReducer: customerReducer.ICustomerState;
  loginReducer: loginReducer.ILoginState;
  licenseReducer: licenseReducer.ILicenseState;
  popupReducer: popupReducer.IPopupState;
}

/*
 * Initial state of the app
 */
export const initialState: IStore = {
  userReducer: userReducer.initialState,
  customerReducer: customerReducer.initialState,
  loginReducer: loginReducer.initialState,
  licenseReducer: licenseReducer.initialState,
  popupReducer: popupReducer.initialState
};

/*
 * Root reducer of the app
 * Returned reducer will be the type of Reducer<IStore>
 */
export const rootReducer = (history: History) =>
  combineReducers<IStore>({
    router: connectRouter(history),
    userReducer: userReducer.reducer,
    customerReducer: customerReducer.reducer,
    loginReducer: loginReducer.reducer,
    licenseReducer: licenseReducer.reducer,
    popupReducer: popupReducer.reducer
  });

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/root-reducer.ts